var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { useDayPicker } from "../../contexts";
/**
 * Render a button HTML element applying the reset class name.
 */

export var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _a = useDayPicker(),
      classNames = _a.classNames,
      styles = _a.styles;

  var classNamesArr = [classNames.button_reset, classNames.button];

  if (props.className) {
    classNamesArr.push(props.className);
  }

  var className = classNamesArr.join(' ');

  var style = __assign(__assign({}, styles.button_reset), styles.button);

  if (props.style) {
    Object.assign(style, props.style);
  }

  return /*#__PURE__*/React.createElement("button", __assign({}, props, {
    ref: ref,
    type: "button",
    className: className,
    style: style
  }));
});